const PASSWORD_SPECIAL_CHARACTER = /[!@#$%^&*(),.?":{}|<>]/;

/**
 * 가입 화면에서 입력하는 동안 조건별로 보여주기 위한 목록. validatePassword와 같은 규칙이다.
 */
export const getPasswordChecks = (password) => {
  const value = typeof password === 'string' ? password : '';
  return [
    { id: 'length', label: '8자 이상', ok: value.length >= 8 },
    { id: 'letter', label: '영문', ok: /[a-zA-Z]/.test(value) },
    { id: 'number', label: '숫자', ok: /\d/.test(value) },
    { id: 'special', label: '특수문자', ok: PASSWORD_SPECIAL_CHARACTER.test(value) },
  ];
};

/**
 * 이메일 계정 비밀번호 정책을 한 곳에서 관리한다.
 * Firebase 콘솔의 정책이 더 강한 경우 서버 응답도 별도로 처리해야 한다.
 */
export const validatePassword = (password) => {
  if (typeof password !== 'string' || password.length < 8) {
    return '비밀번호는 8자 이상이어야 해요.';
  }
  if (!/[a-zA-Z]/.test(password)) {
    return '영문자를 포함해주세요.';
  }
  if (!/\d/.test(password)) {
    return '숫자를 포함해주세요.';
  }
  if (!PASSWORD_SPECIAL_CHARACTER.test(password)) {
    return '특수문자(!@#$%^&* 등)를 포함해주세요.';
  }
  return null;
};

